<template>
  <security-page>
    <template #left>
      <page-illustration :src="illustration" />
    </template>
    <template #right>
      <login-form />
    </template>
  </security-page>
</template>

<script>
import SecurityPage from '@/views/foravila/security/components/SecurityPage.vue'
import PageIllustration from '@/views/foravila/security/components/PageIllustration.vue'
import LoginForm from '@/views/foravila/security/components/LoginForm.vue'

export default {
  components: {
    SecurityPage,
    PageIllustration,
    LoginForm,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      illustration: require('@/assets/images/pages/login-v3.svg'),
    }
  },
}
</script>
